import styled, { css } from 'styled-components';
import { darkMode, darkPalette } from '../../core/theme/darkTheme';

export const TimerTime = styled.div<{ $hideTimer?: boolean }>`
  background-color: rgba(229, 86, 86, 1);
  border-radius: 8px;
  padding: 6px 8px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 12px 0;

  span {
    color: rgba(255, 255, 255, 1);
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    ${({ theme }) => css`
			margin-${theme.isRtl ? 'right' : 'left'}: 8px;
		`}
  }

  ${({ $hideTimer }) =>
    $hideTimer &&
    css`
      display: none;
    `}
  ${darkMode(css`
    background-color: ${darkPalette.dangerSurface};
  `)}
`;

export const VerticalTimer = styled.div`
  display: flex;
  padding: 4px 12px;
  background-color: #c0e5de;
  border-radius: 12px;
`;

export const TimerColumn = styled.div<{ $start?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  ${({ $start }) =>
    $start &&
    css`
      justify-content: flex-start;
      font-size: 20px;
      line-height: 24px;
      font-weight: 700;
      color: #3bb899;
      margin-top: -3px;
    `};
  span {
    font-size: 10px;
    line-height: 16px;
    color: #323232;
  }
`;

export const TimerCount = styled.div`
  font-size: 20px;
  line-height: 24px;
  font-weight: 700;
  color: #3bb899;
`;
